export default "__VITE_ASSET__2Et8DJRn__"